import React, { useEffect, useState } from 'react';
import '../../styles/Alumni/classAlumniProfiles.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';
import { displaySnackbar } from '../../utilities';
import { v4 } from 'uuid';

// 👇️ helper components
import UserProfileCard from '../../components/UserProfileCard';
import { get_alumni_uuid } from '../Home/LoggedIn_Home';

export default function ClassAlumniProfiles() {
    const location = useLocation();
    const { state } = location;
    const [year, setYear] = useState();
    const [allAlumni, setAllAlumni] = useState([]);
    const [alumni, setAlumni] = useState([]);
    const [searchValue, setSearchValue] = useState();
    const [searchOption, setSearchOption] = useState('username');
    const navigate = useNavigate();

    useEffect(() => {
        let path = window.location.pathname?.split('/');
        let the_year = path[path.length - 1];
        setYear(the_year);
        if (state?.alumni) {
            setAllAlumni(state?.alumni?.filter((item) => item?.uuid !== get_alumni_uuid()));
            setAlumni(state?.alumni?.filter((item) => item?.uuid !== get_alumni_uuid()));
        } else {
            fetch(`${BASE_URL}/alumni/all`)
                .then(async (response) => {
                    let data = await response.json();
                    let fetched_alumni = data?.all_alumni;
                    let filtered_alumni = fetched_alumni?.filter(
                        (item) => item?.classYear == the_year && item?.uuid !== get_alumni_uuid()
                    );

                    setAlumni(filtered_alumni || []);
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                    } else {
                        displaySnackbar('Could not fetch alumni.', true);
                    }
                    console.log(error);
                });
        }
    }, []);

    // 👇️ handler for searching alumni based on user selected option
    const searchAlumniByCustomOption = (text) => {
        setSearchValue(text);
        setAlumni(allAlumni?.filter((item) => item?.uuid !== get_alumni_uuid()));
        text = text?.toLowerCase();
        if (text) {
            let filteredAlumni = [];
            switch (searchOption) {
                case 'username':
                    filteredAlumni = allAlumni?.filter((item) =>
                        item?.username?.toLowerCase()?.includes(text)
                    );
                    break;
                case 'email':
                    filteredAlumni = allAlumni?.filter((item) =>
                        item?.email?.toLowerCase()?.startsWith(text)
                    );
                    break;
                case 'firstname':
                    filteredAlumni = allAlumni?.filter((item) =>
                        item?.firstName?.toLowerCase()?.includes(text)
                    );
                    break;
                case 'lastname':
                    filteredAlumni = allAlumni?.filter((item) =>
                        item?.lastName?.toLowerCase()?.includes(text)
                    );
                    break;
                case 'position':
                    filteredAlumni = allAlumni?.filter((item) =>
                        item?.positionName?.toLowerCase()?.includes(text)
                    );
                    break;
                default:
                    setAlumni(allAlumni);
                    break;
            }
            setAlumni(filteredAlumni);
        } else {
            setAlumni(allAlumni?.filter((item) => item?.uuid !== get_alumni_uuid()));
        }
    };

    return (
        <div className='alumni-section'>
            <button className='go-back-btn' onClick={() => navigate('/alumni')}>
                👈️ Go back to classes
            </button>
            <h1
                className='class-alumni-profiles-header'
                style={{
                    textAlign: 'center',
                    marginTop: '1rem',
                    color: '#eee',
                }}
            >
                Class of{' '}
                <i style={{ textDecoration: 'underline', fontWeight: '200', color: 'gold' }}>
                    {year}
                </i>
            </h1>

            <div className='searchBox-container'>
                <input
                    type={'search'}
                    name='search'
                    className='searchBox'
                    placeholder={`search alumni by ${searchOption}...`}
                    value={searchValue}
                    onChange={(e) => searchAlumniByCustomOption(e.target.value)}
                />

                <h1 className='search-options-header'>Search by</h1>
                <div className='search-options-box'>
                    <label htmlFor='radio-username'>
                        {' '}
                        Username
                        <input
                            type='radio'
                            name='radio-username'
                            id='radio-username'
                            onChange={() => setSearchOption('username')}
                            checked={searchOption === 'username' ? true : false}
                        />
                    </label>
                    <label htmlFor='radio-email'>
                        Email
                        <input
                            type='radio'
                            name='radio-email'
                            id='radio-email'
                            onChange={() => setSearchOption('email')}
                            checked={searchOption === 'email' ? true : false}
                        />
                    </label>
                    <label htmlFor='radio-firstName'>
                        First name
                        <input
                            type='radio'
                            name='radio-firstName'
                            id='radio-firstName'
                            onChange={() => setSearchOption('firstname')}
                            checked={searchOption === 'firstname' ? true : false}
                        />
                    </label>
                    <label htmlFor='radio-lastName'>
                        Last name
                        <input
                            type='radio'
                            name='radio-lastName'
                            id='radio-lastName'
                            onChange={() => setSearchOption('lastname')}
                            checked={searchOption === 'lastname' ? true : false}
                        />
                    </label>
                    <label htmlFor='radio-position'>
                        Position
                        <input
                            type='radio'
                            name='radio-position'
                            id='radio-position'
                            onChange={() => setSearchOption('position')}
                            checked={searchOption === 'position' ? true : false}
                        />
                    </label>
                </div>
            </div>

            {alumni?.length > 0 ? (
                <div className='alumni-profiles'>
                    {alumni.map((single_alumni, index) => (
                        <UserProfileCard alumni={single_alumni} key={`alumni #${index}-${v4()}`} />
                    ))}
                </div>
            ) : (
                <div className='empty-alumni-profile'>
                    <h1 className='empty-alumni-text'>No alumni profiles available now.</h1>
                </div>
            )}
        </div>
    );
}
